/* eslint-disable @typescript-eslint/naming-convention */
import { WritableSignal } from '@angular/core';
import { MembershipProduct, NameTid } from '@app/core/models';

export interface MembershipProductMobile extends MembershipProduct {
  index: number;
  discount?: number;
  priceWithDiscount?: number;
  isProcessing?: WritableSignal<boolean>;
}

export interface MembershipCategories extends NameTid {
  productId?: string;
}

/**
 * Configuration for faq based by the membership plans.
 */
export const categoryTerms: MembershipCategories[] = [
  {
    name: 'kiter',
    tid: 407,
    productId: '2',
    // tid: 405, // stage
  },
  {
    name: 'instructor',
    tid: 408,
    productId: '3',
    // tid: 406, // stage
  },
  {
    name: 'assistant',
    tid: 409,
    productId: '22',
    // tid: 407, // stage
  },
  {
    name: 'examiner',
    tid: 410,
    // tid: 408, // stage
  },
];

/**
 * Type to define the configuration for the action to pay a membership.
 */
export type MembershipPayActionConfiguration = {
  /**
   * Initial condition to meet to enable this configuration.
   */
  condition: () => boolean;
  actions: {
    /**
     * Product ids to enable this action.
     */
    productIds: string[];
    /**
     * Disable the button to pay if true.
     */
    disableButtonToPay?: boolean;
    /**
     * Action to take if the initial condition and product ids are met.
     */
    action?: (product: MembershipProductMobile) => void;
  }[];
};
